require('./mortgageRequestGoToDocCenter.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @ helpers
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKLink } = require('commonsComponents/OKLink');

const MortgageRequestGoToDocCenter = (props) => {
    const LinkToDocumentation = '/myprofile/mortgage/documentation';
    const poeditorRequestManagerDocsPrefix = 'mortgageRequestManagerDocuments';
    const docCenterClassName = classnames('mortgage-request-goto-doc-center', {
        'mortgage-request-goto-doc-center--margin-bottom': props.marginBottom
    });
    return (
        <div className={docCenterClassName}>
            <FormattedText
                value={`${poeditorRequestManagerDocsPrefix}-${poeditorRequestManagerDocsPrefix}_RNCvisitDocumentationCenter`}
            />
            <OKLink modifier="emphasize" to={LinkToDocumentation}>
                <FormattedText
                    value={`${poeditorRequestManagerDocsPrefix}-${poeditorRequestManagerDocsPrefix}_RNClinkDocumentationCenter`}
                />
            </OKLink>
        </div>
    )
}

MortgageRequestGoToDocCenter.propTypes = {
    marginBottom: PropTypes.bool
};

module.exports = MortgageRequestGoToDocCenter;